// extracted by mini-css-extract-plugin
module.exports = {"container":"employee_container__3_Fs-","switchArea":"employee_switchArea__3qGFT","timeclock":"employee_timeclock__1zy3o","clockInContainer":"employee_clockInContainer__2QC_r"};